import { UAParser } from 'ua-parser-js';
// By default it takes ua string from current browser's window.navigator.userAgent
import { testWebview } from './utilities/webViewRegExp';
import { extensions } from './utilities/ua-parser-extensions';

export enum DeviceType {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

export interface UserAgent {
  deviceVendor: string;
  deviceModel: string;
  deviceOs: string;
  osVersion: string;
  browserName: string;
  browserVersion: string;
  deviceType: DeviceType;
  isAndroidDevice: boolean;
  isIpad: boolean;
  isAppleDevice: boolean;
  isMobile: boolean;
  isDesktop: boolean;
  isChrome: boolean;
  isSamsungBrowser: boolean;
  isMobileSafari: boolean;
  isWebView: boolean;
}

export class UserAgentImplementation implements UserAgent {
  public deviceVendor: string;

  public deviceModel: string;

  public deviceOs: string;

  public osVersion: string;

  public browserName: string;

  public browserVersion: string;

  public deviceType: DeviceType;

  public isAndroidDevice: boolean;

  public isIpad: boolean;

  public isAppleDevice: boolean;

  public isMobile: boolean;

  public isDesktop: boolean;

  public isChrome: boolean;

  public isSamsungBrowser: boolean;

  public isMobileSafari: boolean;

  public isWebView: boolean;

  constructor(
    { userAgentSource, maxTouchPoints } = {
      userAgentSource: window.navigator.userAgent,
      maxTouchPoints: window.navigator.maxTouchPoints,
    }
  ) {
    const userAgent = new UAParser(userAgentSource, extensions);

    const browser = userAgent.getBrowser();
    const device = userAgent.getDevice();
    const os = userAgent.getOS();

    const userAgentInvalidMessage = 'FAILED_PARSING_DATA_FROM_USER_AGENT';

    this.deviceVendor = device.vendor || userAgentInvalidMessage;

    this.deviceModel = device.model || userAgentInvalidMessage;

    this.deviceOs = os.name || userAgentInvalidMessage;

    this.osVersion = os.version || userAgentInvalidMessage;

    this.browserName = browser.name || userAgentInvalidMessage;

    this.browserVersion = browser.version || userAgentInvalidMessage;

    this.isAndroidDevice = os.name?.toLowerCase() === 'android';

    // See https://stackoverflow.com/a/58017456/10600871, needed to determine envs where an
    // mobile app could be installed
    this.isIpad = Boolean(
      this.deviceOs?.toLowerCase() === 'mac os' && maxTouchPoints && maxTouchPoints > 2
    );

    this.isAppleDevice = this.deviceOs?.toLowerCase() === 'ios' || this.isIpad;

    this.isMobile = this.isAppleDevice || this.isAndroidDevice;

    this.isDesktop = !this.isMobile;

    this.isChrome = browser && browser.name?.toLowerCase() === 'chrome';

    this.isSamsungBrowser = browser && browser.name?.toLowerCase() === 'samsung browser';

    this.isMobileSafari = browser && browser.name?.toLowerCase() === 'mobile safari';

    this.isWebView = testWebview(userAgentSource);

    this.deviceType = this.isMobile ? DeviceType.MOBILE : DeviceType.DESKTOP;
  }
}

export const userAgent = new UserAgentImplementation();
